import { StateCreator } from "zustand";
import { ENoticeTabs } from "@publicPortal/pages/enforcementNotice/EnforcementNoticeTabs";

export interface EnforcementNoticeDetailsState {
    [x: string]: ENoticeTabs;
}

export interface EnforcementNoticeDetailsSlice {
    enforcementNoticeDetails: EnforcementNoticeDetailsState;
    setEnforcementNoticeDetails: (state: EnforcementNoticeDetailsState) => void;
    updateEnforcementNoticeTab: (recordId: string | number, tab: ENoticeTabs) => void;
}

const initialEnforcementNoticeDetailsState: EnforcementNoticeDetailsState = {};

export const createEnforcementNoticeDetailsSlice: StateCreator<EnforcementNoticeDetailsSlice, [], [], EnforcementNoticeDetailsSlice> = (set) => ({
    enforcementNoticeDetails: initialEnforcementNoticeDetailsState,
    setEnforcementNoticeDetails: (state) => set({ enforcementNoticeDetails: state }),
    updateEnforcementNoticeTab: (recordId, tab) =>
        set((state) => ({ enforcementNoticeDetails: { ...state.enforcementNoticeDetails, [recordId]: tab } })),
});

